import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const mainCategories = categories;

  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-store-2-line"></i>
            Shop by Category
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            Explore All Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Click any category below to browse products on the main VigorBuy Spreadsheet store.
            Each category offers a curated selection of premium items.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {mainCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center p-5 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-background-50 border border-background-200/50 text-foreground-600 group-hover:bg-primary-500 group-hover:text-background-50 group-hover:border-primary-500 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors text-center whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1 text-center line-clamp-2">
                {cat.description}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}